module.exports = __webpack_public_path__ + "static/img/notice14.97b975c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice14.png
// module id = ivWz
// module chunks = 2